import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import './assets/scss/index.scss';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import dataV from '@jiaminghi/data-view'

import VideoPlayer from 'vue-video-player'
// 引入vue-video-player的样式
import 'vue-video-player/src/custom-theme.css'
// 引入vue-video-player的基本样式
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)

Vue.use(VueRouter)

Vue.config.productionTip = false

Vue.use(dataV);
Vue.use(ElementUI);

const routes = [
  { path: '/', component: () => import('./components/HelloWorld.vue') },
  { path: '/video', component: () => import('./views/video.vue') }
];
 
// 创建路由实例
const router = new VueRouter({
  routes // （缩写）相当于 routes: routes
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
